let zaehler = 1;

const produktOptionen = `
  <option value="">— Produkt auswählen —</option>
  <optgroup label="Standard Clips">
    <option>Blind Clip A3</option>
    <option>Clip - B66</option>
    <option>Clip A1</option>
    <option>Clip A11</option>
    <option>Clip A12</option>
    <option>Clip A13</option>
    <option>Clip A14</option>
    <option>Clip A2</option>
    <option>Clip A21</option>
    <option>Clip A24</option>
    <option>Clip A26</option>
    <option>Clip A28</option>
    <option>Clip A3</option>
    <option>Clip A30</option>
    <option>Clip A35</option>
    <option>Clip A37</option>
    <option>Clip A38</option>
    <option>Clip A43</option>
    <option>Clip A44</option>
    <option>Clip A67</option>
    <option>Clip A8</option>
    <option>Clip A9</option>
    <option>Clip B15</option>
    <option>Clip B28</option>
    <option>Clip B37</option>
    <option>Clip B4</option>
    <option>Clip B45</option>
    <option>Clip B71</option>
    <option>Clip D6</option>
    <option>Clip F10</option>
    <option>Clip F7</option>
    <option>Clip K3</option>
    <option>Clip K5</option>
    <option>Clip N16</option>
    <option>Clip N19</option>
    <option>Clip P18</option>
    <option>Clip P2</option>
    <option>Clip P45</option>
    <option>Clip P48</option>
    <option>Clip P5</option>
    <option>Clip P53</option>
    <option>Clip P6</option>
    <option>Clip P79</option>
    <option>Clip R23</option>
    <option>Clip R27</option>
    <option>Clip R35</option>
    <option>Clip R36</option>
    <option>Clip R55</option>
    <option>Clip R79</option>
    <option>Clip R84</option>
    <option>Clip S103</option>
    <option>Clip S104</option>
    <option>Clip S108</option>
    <option>Clip S20</option>
    <option>Clip S60</option>
    <option>Clip S70</option>
    <option>Clip S81</option>
    <option>Clip T1</option>
  </optgroup>
  <optgroup label="Multiclips">
    <option>Adapterclip</option>
    <option>MC1 - Multiclip</option>
    <option>MC3 - Multiclip</option>
    <option>MC4 - Multiclip</option>
    <option>MC5 - Multiclip</option>
    <option>MC10 - Multiclip</option>
    <option>MC11 - Multiclip</option>
    <option>MC12 - Multiclip</option>
    <option>MC13 - Multiclip</option>
    <option>MC14 - Multiclip</option>
  </optgroup>
  <optgroup label="Kunststoffkörbe">
    <option>Kunststoffkorb, 150x100x57 mm</option>
    <option>Kunststoffkorb</option>
    <option>Trennkamm für Korb</option>
  </optgroup>
  <optgroup label="Trennkämme">
    <option>Trennkamm klein</option>
    <option>Trennkamm mittel</option>
    <option>Trennkamm groß</option>
    <option>Trennkamm heavy, 300 mm</option>
    <option>Trennkamm heavy, 400 mm</option>
  </optgroup>
  <optgroup label="Kunststoff Werkstückträger">
    <option>ZELL® Factory</option>
    <option>ZELL® Factory Deckel</option>
    <option>ZELL® Carrier "heavy"</option>
    <option>ZELL® Carrier "light"</option>
    <option>ZELL® Carrier Deckel</option>
  </optgroup>
  <optgroup label="Edelstahl Werkstückträger">
    <option>ZELL® Edelstahl</option>
  </optgroup>
  <optgroup label="Zubehör">
    <option>Beschriftungsblech</option>
  </optgroup>
`;

const maxEins = [
  'ZELL® Factory', 'ZELL® Factory Deckel', 'ZELL® Carrier "heavy"',
  'ZELL® Carrier "light"', 'ZELL® Carrier Deckel', 'ZELL® Edelstahl'
];

window.updateStueckzahl = function(select) {
  const zeile = select.closest('.produkt-zeile');
  const stueckzahl = zeile.querySelector('.produkt-stueckzahl');
  const hinweis = zeile.querySelector('.stueckzahl-hinweis');
  const wert = select.value;
  if (maxEins.includes(wert)) {
    stueckzahl.max = 1;
    stueckzahl.value = 1;
    hinweis.textContent = 'Max. 1 Stk. bei Werkstückträgern';
  } else if (wert === '') {
    stueckzahl.max = '';
    stueckzahl.value = '';
    hinweis.textContent = '';
  } else {
    stueckzahl.max = 5;
    if (stueckzahl.value > 5) stueckzahl.value = 5;
    hinweis.textContent = 'Max. 5 Stk.';
  }
}

window.addZeile = function() {
  zaehler++;
  const liste = document.getElementById('produkt-liste');
  const zeile = document.createElement('div');
  zeile.className = 'produkt-zeile';
  zeile.innerHTML = `
    <div class="produkt-select-wrap">
      <select name="contact[produkt_${zaehler}]" required class="produkt-select" onchange="updateStueckzahl(this)">
        ${produktOptionen}
      </select>
    </div>
    <div class="stueckzahl-wrap">
      <input type="number" name="contact[stueckzahl_${zaehler}]" min="1" max="5" placeholder="Stückzahl" class="produkt-stueckzahl" required>
      <span class="stueckzahl-hinweis"></span>
    </div>
    <div class="produkt-remove-wrap">
      <button type="button" class="produkt-remove" onclick="removeZeile(this)">✕</button>
    </div>
  `;
  liste.appendChild(zeile);
}

window.removeZeile = function(btn) {
  btn.closest('.produkt-zeile').remove();
}